module.exports = __webpack_public_path__ + "static/img/4.3b83cf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/4.png
// module id = YVfC
// module chunks = 0